import React, { useEffect, useState } from "react";
import { Form, Input, Button, Typography, message, Spin, Col, Row, Divider } from "antd";
import { useHistory } from "react-router-dom";
import LeftLayout from "../pageHeader/LeftLayout";
import { routes } from "../../routes/Routes";
import { RightOutlined } from '@ant-design/icons';
import _LoanOfficerService from "../../modules/LoanOfficerService";
import { COMMON_ERROR_MSG, SESSION_TOKEN } from "../../constants/constants";
import Login from "../../components/Login/Login";


const { Title, Link } = Typography;

const AccountLoginForLoanOfficer = () => {

    const history = useHistory();
    const [loading, setLoading] = useState(false);

    const onFinish = async (values) => {
        // debugger
        try {
            setLoading(true);
            const reqObj = {
                Email: values.email,
                Password: values.password,
            };

            const res = await _LoanOfficerService.loanOfficerLogin(reqObj);
            // debugger;
            console.log(res);
             if (res?.data?.IsSuccess) {
                // debugger
                setLoading(false);
                localStorage.setItem("LoanOfficerEmailId", res.data.Obj.Email);
                localStorage.setItem("LoanOfficerId", res.data.Obj.Id);
                localStorage.setItem("LoanOfficerFirstName", res.data.Obj.FirstName);
                localStorage.setItem(SESSION_TOKEN, res.data.Obj.AuthToken);
                localStorage.setItem("userRole", res?.data?.Obj?.Role);
                localStorage.setItem("IsLoanofficerFlag", JSON.stringify(true));
                localStorage.setItem("listUserRoles", JSON.stringify(res?.data?.Obj?.listUserRoles));
                localStorage.setItem("Password", values.password);

                setLoading(false);
                history.push(routes.loanOfficerDashboard.path);
            } else {
                // debugger
                setLoading(false);
                message.error(res.data.Message || COMMON_ERROR_MSG);
            }

            // if (res?.status === 200 && res?.data?.AuthToken) {
            //    // message.success("Login successful!");

            //     localStorage.setItem("LoanOfficerEmailId", res.data.Email);
            //     localStorage.setItem("LoanOfficerId", res.data.Id);
            //     localStorage.setItem("LoanOfficerFirstName", res.data.FirstName);
            //     localStorage.setItem(SESSION_TOKEN, res.data.AuthToken);
            //     localStorage.setItem("userRole", res?.data?.Obj?.Role);
            //     localStorage.setItem("IsLoanofficerFlag", JSON.stringify(true));

            //     setLoading(false);
            //     history.push(routes.loanOfficerDashboard.path);

            // } else {
            //     message.error("Invalid login credentials");
            //     setLoading(false);
            // }
        } catch (err) {
            console.error(err);
            message.error("An error occurred during login");
            setLoading(false);
        }
    };

    const forgotPassword = () => {
        history.push(routes.forgotLoanOfficerLoginPasswordSendOTP.path);
    };

    const bankerLogin = () => {
        history.push(routes.accountLogin.path);
    }

    const bankerAdminLogin = () => {
        history.push(routes.bankAdminLogin.path);
    }

    const loanOfficerLogin = () => {
        history.push(routes.accountLoginForLoanOfficer.path);
    }

    const complianceAdminLogin = () => {
        history.push(routes.complianceAdminLogin.path);
    }

    const applicantLogin = () => {
        history.push(routes.registeredEmail.path);
    }

    const createNewAccount = () => {
        history.push(routes.enterEmailForLoanOfficer.path);
    }


    return (
        <Spin spinning={loading}>
            <Login 
                role="loanOfficer"
                title="Credit Portal"
                onFinishHandle={onFinish}
                createNewAccount={createNewAccount}
                forgotPassword={forgotPassword}
                bankerLogin={bankerLogin}
                bankerAdminLogin={bankerAdminLogin}
                loanOfficerLogin={loanOfficerLogin}
                complianceAdminLogin={complianceAdminLogin}
                isNewAccountCreateFlag={false}
                applicantLogin={applicantLogin}
            />
            {/* <LeftLayout>
                <div className="w450 loan-login-page">
                    <Title level={3} style={{ fontWeight: "bold", color: "#d3d3d3", marginBottom: 60 }}>
                        Loan Officer’s Portal
                    </Title>


                    <Form
                        name="account-login"
                        layout="vertical"
                        onFinish={onFinish}
                        requiredMark={true}
                    >
                        <Form.Item
                            label="Email"
                            name="email"
                            rules={[
                                {
                                    required: true,
                                    message: "Email is required",
                                },
                                { type: 'email', message: 'Enter a valid Email' }
                                // {
                                //     pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.(com|in|org|net|edu|gov|co|ai|us|info|biz|me|io|tech|app|dev|cloud|store|xyz|tv|name|email|pro|mil|k12|state)$/,
                                //     message: "Please enter a valid email address with a valid domain (e.g., .com, .in)",
                                // },
                            ]}
                        >
                            <Input autoComplete="email" placeholder="Enter Your Email" maxLength={50} />
                        </Form.Item>

                        <Form.Item
                            label="Password"
                            name="password"
                            rules={[{ required: true, message: "Password is required" }]}
                        >
                            <Input.Password autoComplete="current-password" placeholder="Enter Password" maxLength={30} />
                        </Form.Item>
                        <div
                            style={{ textAlign: "right", marginTop: 16 }} className="forgot-text"
                        >
                            <Link onClick={() => history.push(routes.forgotLoanOfficerLoginPasswordSendOTP.path)} style={{ fontWeight: "bold" }}>
                                Forgot Password? <RightOutlined />
                            </Link>

                        </div>
                        
                        <Row justify="space-between" align="middle" style={{ marginBottom: 24 }}>
                            <Col>
                                <Form.Item className="btnlogin">
                                    <Button
                                        htmlType="submit"
                                        className="login-btn"
                                        shape="round"
                                        style={{
                                            fontWeight: "bold",
                                            marginTop: 10,
                                            marginBottom: 10,
                                        }}
                                    >
                                        Login <RightOutlined />
                                    </Button>
                                </Form.Item>
                            </Col>
                            <Col className="displayNone">
                                <Link onClick={() => history.push(routes.enterEmailForLoanOfficer.path)} style={{ fontWeight: "bold" }}>
                            Create A New Account  <RightOutlined />
                        </Link>
                            </Col>
                        </Row>

                       
                    </Form>
                      <Divider plain orientation="center">
                        OR
                    </Divider>

                    <Form.Item className="mt20 mb10">
                        <Link onClick={() => history.push(routes.registeredEmail.path)}>
                            Applicant Login <RightOutlined />
                        </Link>
                    </Form.Item>
                    <Form.Item className="mb10">
                        <Link onClick={() => history.push(routes.accountLogin.path)}>
                            Banker Login <RightOutlined />
                        </Link>
                    </Form.Item>
                      <Form.Item className="mb10">
                        <Link onClick={() => history.push(routes.bankAdminLogin.path)}>
                            Bank Admin Login <RightOutlined />
                        </Link>
                    </Form.Item>
                </div>
            </LeftLayout> */}
        </Spin>
    );
};

export default AccountLoginForLoanOfficer;
